import { defaultHref, type AppNotification, type NotifKind } from "../stores/notificationsStore";

const base: AppNotification[] = [
  {
    id: "n1",
    kind: "broker_adopted",
    title: "Ana Lima aderiu ao lançamento Reserva das Águas",
    at: "há 2h",
    read: false,
    href: "/brokers",
  },
  {
    id: "n2",
    kind: "proposal_created",
    title: "Nova proposta (PRP-2041) em Skyline Corporate",
    at: "há 5h",
    read: false,
    href: "/proposals/p1",
  },
  {
    id: "n3",
    kind: "proposal_accepted",
    title: "Proposta aceita em Vista Mar Residencial",
    at: "ontem",
    read: true,
    href: "/proposals/p2",
  },
];

// Volume extra (mock) para paginar a lista.
const genKinds: NotifKind[] = ["broker_adopted", "proposal_created", "proposal_accepted"];
const genTitles = [
  "Carla Nunes aderiu ao lançamento Jardim Botânico",
  "Nova proposta (PRP-2038) em Vista Mar Residencial",
  "Proposta recusada em Skyline Corporate",
  "Bruno Sá aderiu ao lançamento Skyline Corporate",
  "Nova proposta (PRP-2035) em Reserva das Águas",
  "Proposta aceita em Reserva das Águas",
  "Diego Rocha aderiu ao lançamento Vista Mar Residencial",
  "Nova proposta (PRP-2031) em Reserva das Águas",
  "Proposta em contraproposta (PRP-2028)",
  "Ana Lima aderiu ao lançamento Skyline Corporate",
  "Nova proposta (PRP-2019) em Vista Mar Residencial",
  "Proposta aceita em Skyline Corporate",
];
const genAt = ["ontem", "há 2 dias", "há 3 dias", "há 4 dias", "há 5 dias", "há 1 semana"];

export const mockNotifications: AppNotification[] = [...base];
for (let i = 0; i < genTitles.length; i++) {
  const kind = genKinds[i % genKinds.length]!;
  mockNotifications.push({
    id: `ng${i}`,
    kind,
    title: genTitles[i]!,
    at: genAt[i % genAt.length]!,
    read: i % 3 !== 0,
    href: defaultHref(kind),
  });
}
